module.exports = __webpack_public_path__ + "img/tg5_query.029ae58a.png";